module.exports = Object.freeze({
  /*eslint-disable */
  PASSWORD_PATTERN:
    /^(?=.*[0-9])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=.*[A-Z]).{14,}$/,
  EMAIL_PATTERN:
    /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
  LOGO_PATTERN: /\.(png|svg)$/i,
  /*eslint-enable */
});
